import Backdrop from "@mui/material/Backdrop";
import RingLoader from "react-spinners/RingLoader";

const PageLoader = ({ isLoading }) => {
  return (
    <Backdrop open={isLoading} sx={{ color: "fff", zIndex: 1000000000 }}>
      <RingLoader color="" height={100} width={100} />
    </Backdrop>
  );
};

export default PageLoader;
